import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  bannerTryShippingApiAddonTitle: {
    description: 'Title for getting the Shipping API add-on banner',
    defaultMessage: 'Get the Shipping API add-on',
    id: 'xVusLz',
  },
  bannerTryShippingApiAddonMessage: {
    description: 'Message for getting the Shipping API add-on banner',
    defaultMessage: 'Access the new Shipping API endpoints when you enable the Shipping API add-on.',
    id: 'oFxKba',
  },
  bannerShippingDetailsButton: {
    description: 'Button title for the Upsell banner',
    defaultMessage: 'Shipping API Details',
    id: '5LsdXX',
  },
});
